export const SERVICE_TYPE_MAPPING: { [key: string]: string } = {
  petSitting: 'Pet Sitting',
  petHosting: 'Pet Hosting',
  petDayCare: 'pet Day Care',
  houseVisiting: 'House Visiting',
  dogWalking: 'Dog Walking',
  training: 'Dog Training',
  grooming: 'Dog Grooming',
};
